<!-- <div class="d-flex justify-content-between align-items-center mt-2">
    <button class="btn btn-outline-primary btn-sm" (click)="prev()" [disabled]="currentPage() === 1">
    Previous
    </button>
    <span>Page {{ currentPage() }} of {{ totalPages() }}</span>
    <button class="btn btn-outline-primary btn-sm" (click)="next()" [disabled]="currentPage() === totalPages()">
    Next
    </button>
</div> -->



<nav *ngIf="totalPages() > 1" class="mt-3">
  <ul class="pagination justify-content-center pagination-sm">

    <!-- Prev -->
    <li class="page-item" [class.disabled]="currentPage() === 1">
      <button class="page-link" (click)="prev()">Prev</button>
    </li>

    <!-- Page Numbers -->
    <li
      class="page-item"
      *ngFor="let page of visiblePages()"
      [class.active]="page === currentPage()"
      [class.disabled]="!isNumber(page)"
    >
      <!-- Number -->
      <button
        *ngIf="isNumber(page)"
        class="page-link"
        (click)="goToPage(page)">
        {{ page }}
      </button>

      <!-- Ellipsis -->
      <span *ngIf="!isNumber(page)" class="page-link">
        …
      </span>
    </li>

    <!-- Next -->
    <li class="page-item" [class.disabled]="currentPage() === totalPages()">
      <button class="page-link" (click)="next()">Next</button>
    </li>

  </ul>
</nav>

